<!-- 市场拓展目标管理 -->
<template>
  <div class="content freelist" v-loading="pageLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">公司名称</div>
          <el-select
            size="mini"
            filterable
            clearable
            v-model="page.tenantGuid"
            placeholder="请选择"
            class="ipt-sty"
            
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
              
            >
            </el-option>
          </el-select>
          
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">产品名称</div>
          <el-input
            class="ipt-sty"
            size="small"
            clearable
            placeholder="请输入"
            v-model="page.goodsName"
          >
          </el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">年份</div>
          <el-date-picker
            v-model="page.year"
            format="yyyy年"
            type="year"
            value-format="yyyy"
            placeholder="选择年份">
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search(true)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box" >
      <div class="button-area">
        <el-button size="mini" type="info" @click="addFieldConfig"
          >新增市场拓展目标</el-button>
        <el-button size="mini"  @click="batchImport"
          >批量导入</el-button>
          <el-button  size="mini" type="default" @click="delTarget(2,multipleSelection)" >批量删除</el-button>
      </div>
      <el-table
        :data="tableData"
        stripe
        border
        ref="multipleTable"
        :height="tableHeight"
        style="width: 100%"
        tooltip-effect="light"
        v-loading="loading"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="40"
          header-align="center"
          align="center"
          fixed="left"></el-table-column>
        <el-table-column
          label="序号"
          header-align="center"
          align="center"
          fixed="left"
          width="60"
        >
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column
          prop="tenantName"
          label="药企名称"
          show-overflow-tooltip
          header-align="center"
          fixed="left"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>
        <el-table-column
          prop="goodsName"
          label="产品名称"
          show-overflow-tooltip
          header-align="center"
          fixed="left"
          align="left"
          width="150"
        >
          <template slot-scope="scope">  {{scope.row.goodsName }}</template>
        </el-table-column>
        <el-table-column
          prop="year"
          label="年份"
          sortable
          header-align="center"
          align="left"
          width="72"
        >
          <template slot-scope="scope">{{ scope.row.year  }}</template>
        </el-table-column>

        <el-table-column
          prop=" janExpandTarget"
          label="1月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
        <template slot-scope="scope">{{ (scope.row.janExpandTarget) | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="febExpandTarget"
          label="2月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{
            (scope.row.febExpandTarget ) | numFmt | numDigit
          }}</template>
        </el-table-column>
        <el-table-column
          prop="marExpandTarget"
          label="3月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.marExpandTarget)| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="aprExpandTarget"
          label="4月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.aprExpandTarget )| numFmt | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="mayExpandTarget"
          label="5月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{  (scope.row.mayExpandTarget )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="junExpandTarget"
          label="6月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.junExpandTarget )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="julExpandTarget"
          label="7月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.julExpandTarget )| numFmt | numDigit  }}</template>
        </el-table-column>
        <el-table-column
          prop="augExpandTarget"
          label="8月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.augExpandTarget )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="septExpandTarget"
          label="9月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="150"
        >
          <template slot-scope="scope">{{ (scope.row.septExpandTarget )| numFmt | numDigit  }}</template>
        </el-table-column>
        <el-table-column
          prop="octExpandTarget"
          label="10月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ ( scope.row.octExpandTarget )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="novExpandTarget"
          label="11月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{  (scope.row.novExpandTarget )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="decExpandTarget"
          label="12月拓展目标金额（元）"
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ (scope.row.decExpandTarget )| numFmt | numDigit}}</template>
        </el-table-column>
        <el-table-column
          prop="expandTargetTotal"
          label="年度拓展目标金额合计（元）"
          header-align="center"
          align="right"
          width="180"
        >
          <template slot-scope="scope">{{ (scope.row.expandTargetTotal )| numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="updateUserName"
          label="操作人"
          header-align="center"
          align="left"
          width="96"
        >
          <template slot-scope="scope">{{
            scope.row.updateUserName || scope.row.createUserName||"-"
          }}</template>
        </el-table-column>
        <el-table-column
          prop="updateTime"
          label="操作时间"
          header-align="center"
          align="left"
          width="160"
        >
          <template slot-scope="scope">{{
            scope.row.updateTime | getTimeDate
          }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          fixed="right"
          min-width="120"
        >
          <template slot-scope="scope">
            <a class="txt-color" @click="targetDetail(scope.row)">详情｜</a>
            <!-- v-if="tableData.createUserId===staffGuid" -->
            <a
              
              class="txt-color"
              @click="addFieldConfig(deepCopy(scope.row))"
              >编辑｜</a
            >
            <a class="txt-color-red" @click="delTarget(1,scope.row.guid)"
              >删除
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>

   
  </div>
</template>

<script>
  import { route } from "@/api/apiRoute";
  import store from "@/store";
  import TabList from "@/components/tab/tabList.vue";
  export default {
    components: {
      TabList,
    },
    data() {
      return {
        tableHeight: window.innerHeight - 280,
        pageLoading:false,
        loading: false,
        textTitle: "",
        showGrade: false,
        checkAll:false,
        multipleSelection:[],//多选
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          tenantGuid:'',
          goodsName:'',
          year:'',
          serviceTenantGuid:''
        },
        modelName: "",
        bizState: "",
        modelGuid:"",
        oldGuid:'',
        tableData: [],
        promiseArr:[],
        configForm: {
          modelName: "", //模型名称
          gradeCycle: "", //评级周期
          bizState: "", //启用状态
          tenant:{},
          tenantName: "", //应用公司
          tenantGuid: "", //应用公司id
          tenantGuidList:[],//应用公司id
          // organisation:{},
          organisationName: "", //应用部门
          organisationGuid: "", //应用部门id
          modelDesc: "", //模型描述
          indicateDetailJson: [], //评级模型指标设置明细
          levelDetailJson: [], //评级模型等级设置明细
        },
        // 应用公司列表
        tenantList: [],
        tenantGuidList: [],
        // 应用部门列表
        departmentList: [],
        tagList: [], //标签指标大类
        // categoryList: [], //评级指标
        
        tabIndex: 0,
      };
    },
    filters: {
      bizStateFilter(val) {
        if (!val) return "-";
        if (val === "Y") {
          return "启用";
        } else if (val === "N") {
          return "禁用";
        }
      },
      
    },
    activated() {
      this.search(false);//false不改变pageindex
    
  },
    created() {
      let userInfo=JSON.parse(localStorage.userInfo)
      this.staffGuid=userInfo.staffGuid
      
      // this.getList();
      this.getTenantList()
      this.search(true);
    },
    mounted() {
      
    },
    watch: {
      
    },
    methods: {
      // 表格多选
      handleSelectionChange(val){
        this.multipleSelection = [];
        val.forEach((item)=>{
          this.multipleSelection.push(item.guid)
        })
        
      },
      // 获取列表
      search(flg) {
        let that = this;
        that.loading = true;
        that.tableData = [];
        if (flg) {
          that.page.pageIndex = 1;
        }
        // that.page.serviceTenantGuid=localStorage.guid
        that.api
          .postJson(
            `/${serverConfig.msSalesPerformService}/marketExpandTarget/list`,
            that.page
          )
          .then((res) => {
            that.loading = false;
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tableData = res.data.data.records;
              that.page.totalPage = res.data.data.totalPages;
              that.page.totalRows = res.data.data.totalRows;
            } else {
              that.$message.error(res.data.msg);
            }
          });
      },
      
      delTarget(flg,guid) {
      // 1为删除单个，2批量删除
      let that = this;
      if (flg === 2) {
        if (that.multipleSelection && that.multipleSelection.length === 0) {
          that.$message.error("请勾选数据！");
          return;
        }
      } else {
        that.multipleSelection = [];
        that.multipleSelection.push(guid);
      }
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.api
            .postJson(
              `/${serverConfig.msSalesPerformService}/marketExpandTarget/del`,
              that.multipleSelection
            )
            .then((res) => {
              if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
                that.$message.success("删除成功");
                that.multipleSelection=[]
                that.$refs.multipleTable.clearSelection();
                that.search(false);
              } else {
                that.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
      
    // 获取应用公司
    getTenantList() {
        let that = this;
        let query ={
          'pageIndex':1,
          'pageSize':-1,
          'bizState':'Y',
          'enterpriseCates':this.$getValueListByKey('上游客户分类')
        }
        that.api
        .postJson(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation`,query)
          .then((res) => {
            if (res.data.code === serverConfig.REQUIRE_SUCCESS_CODE) {
              that.tenantList = res.data.data.records;
              // console.log('tenantList',that.tenantList);
              
            } else {
              that.$message.error(res.data.msg);
            }
          });
    },
      
      deepCopy(val) {
        return JSON.parse(JSON.stringify(val));
      },
      
      // 清空搜索
      emptySearch() {
        this.page.tenantGuid='',
        this.page.goodsName='',
        this.page.year=''
        this.search(true);
      },

      // 新增市场目标
      addFieldConfig(row) {
        this.$router.push({
          path: '/marketingTargetAdd',
          query: {
            guid:row?row.guid:'',
            tenantGuid:this.page.tenantGuid,
            productGuid: localStorage.productGuid,
          },
        });
   
      },
      // 批量导入
      batchImport() {
        this.$router.push({
          path: "/importmarketingTarget",
          query: { 
            productGuid: localStorage.productGuid,
          },
        });
      },
      // 查看详情
      targetDetail(row) {
        this.$router.push({
          path: "/marketingTargetDetail",
          query: { 
            guid:row.guid,
            productGuid: localStorage.productGuid,
          },
        });
      },
 
      // 分页
      handleSizeChange(val) {
        let that = this;
        that.page.pageSize = val;
        this.search();
      },
      handleCurrentChange(val) {
        let that = this;
        that.page.pageIndex = val;
        this.search();
      },
    },
  };
</script>
<style lang="less" scoped>
.show-pop{
  color: #4fa1a4;
}
.tips-class{
  width: 90%;
  margin: auto;
  color: #4fa1a4;
  text-align: left;
  font-size: 12px;
}
  .el-table /deep/ .el-input__inner {
    height: 30px;
    line-height: 40px;
  }
  .search-area /deep/ .el-input__icon {
   
    line-height: 30px;
  }

  .el-range-editor.el-input__inner {
    padding: 0px;
  }

  /deep/ .el-checkbox__label {
    display: none;
  }

  /deep/ .configure-fields {
    width: 800px !important;
  }
  /deep/ .configure-fields .el-dialog__body {
    overflow-y: auto;
    max-height: 600px;
  }
  /deep/ .el-dialog__footer {
    border-top: 1px solid #d9d9d9;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #d9d9d9;
  }
  .field-radio {
  display: flex;
  align-items: center;
}

.field-radio /deep/ .el-form-item__content {
  margin-left: 0 !important;
}
/deep/ .el-form-item {
  margin-bottom: 8px;
}
 /* 选项内容样式 */
 /deep/ .select-content-box {
    width: 92%;
    margin: 0 0px 10px 30px;
  }
  /deep/ .select-content {
    width: 100%;
    /* padding:0 10px; */
    background: #fafafa;
    border: 1px solid #e5e5e5;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }

  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }

  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }

  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }

  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }

  // .content {
  //   background: #fff;
  //   font-size: 18px;
  // }

  .title {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .title span {
    width: 6px;
    height: 14px;
    background: #4fa1a4;
    display: inline-block;
    margin-right: 10px;
  }

  .base {
    background: #fff;
    padding: 10px 0;
  }

  .content h1 {
    margin: 4px 0px;
  }

  .base-content {
    display: flex;
    font-size: 15px;
    padding: 7px 0;
  }

  .base-content .base-info {
    display: flex;
    align-items: center;
    padding: 0 40px;
  }

  .base-content .base-info .base-title {
    word-break: keep-all;
  }

  .button-area {
    display: flex;
    justify-content: flex-start;
    padding: 8px;
    margin-top: 0;
  }

  /deep/.el-checkbox__label {
    display: block;
  }

  .checkbox-show {
    display: flex;
    margin-bottom: 10px;
  }
  .field-show {
    display: flex;
    align-items: center;
    height: 40px;
    padding-left: 10px;
  }

  .product {
    display: flex;
    align-items: center;
  }

  .product-img {
    width: 60px;
    height: 40px;
    margin-right: 15px;
  }

  .product-text {
    width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-col-5 {
    width: 33%;
  }

  .ipt-sty {
    width: 69% !important;
  }
  .add-btn {
    width: 80%;
    height: 28px;
    line-height: 28px;
    margin-top: 8px;
    padding: 0;
  }
  .flex {
    width: 80%;
    margin: auto;
    display: flex;
    justify-content: space-between;
  }
  .flex1 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .checkTag {
    background-color: rgb(242, 242, 242);
  }
  .btn {
    display: none;
  }
  .btn a {
    cursor: pointer;
  }
  .el-table__body tr:hover .btn {
    display: block;
  }

  /deep/.el-tree-node__label {
    width: 80%;
    white-space: normal;
    overflow: hidden;
    text-align: left;
  }

  .el-tree-node__content {
    height: auto;
  }

  .radio-ora {
    margin-right: 12px;
  }

  .staff-type {
    display: inline-block;
    width: 72px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-type-biz {
    display: inline-block;
    width: 52px;
    height: 28px;
    line-height: 28px;
    color: #4fa1a4;
    background: rgba(234, 248, 248, 0.39);
    border-radius: 2px;
  }

  .staff-wrap {
    color: #d8814b;
    background: rgba(255, 238, 224, 0.39);
  }

  .biz-state {
    display: inline-block;
    width: 48px;
    height: 21px;
    line-height: 21px;
    background: rgba(239, 239, 239, 0.38);
    border-radius: 11px;
    margin-left: 5px;
  }

  .select-node {
    margin: 0 0 17px 0;
    text-align: left;
    font-size: 18px;
    color: #323233;
  }

  .custom-tree-node {
    display: inline-flex;
    overflow: hidden;
  }

  .content-main-box {
    overflow-y: visible;
  }

  .search-area-div{
    flex-shrink: 0;
    margin-right: 4px
  }
  .ipt-sty{
    flex: 1;
  }
  .el-col-6{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-12{
    display: flex;
    justify-content: flex-end;
  }
  .el-col-8{
    display: flex;
    // margin-bottom: 15px;
    justify-content: flex-end;
  }
  /* .el-pagination {
    width: calc(100% - 260px - 231px);
  } */
</style>

